// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"845":"84e76041f91cda55","2188":"d7122aee51267700","9063":"f66d4429738d4ece"}[chunkId] + ".css";
};